(function () {
  angular.module(
    "akitabox.core.ui.dialogs.inspectionProgram.create.overrideList",
    []
  );
})();
